import React from "react";

export const CodeEmbed = () => (
  <iframe
    src="https://www.videoask.com/fvgl6u5pl"
    allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;"
    width="100%"
    height="600px"
    style={{ border: "none", borderRadius: "24px" }}
  />
);
